/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Ground_Item_TimeInputs */

const en_auth_ground_item_time = /** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time and capacity`)
};

/** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */
const ar_auth_ground_item_time = en_auth_ground_item_time;

/** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */
const he_auth_ground_item_time = en_auth_ground_item_time;

/** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */
const ur_auth_ground_item_time = en_auth_ground_item_time;

/** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */
const es_auth_ground_item_time = en_auth_ground_item_time;

/** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */
const fr_auth_ground_item_time = en_auth_ground_item_time;

/** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */
const de_auth_ground_item_time = en_auth_ground_item_time;

/** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */
const pt_auth_ground_item_time = en_auth_ground_item_time;

/** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */
const hi_auth_ground_item_time = en_auth_ground_item_time;

/** @type {(inputs: Auth_Ground_Item_TimeInputs) => LocalizedString} */
const bn_auth_ground_item_time = en_auth_ground_item_time;

/**
* | output |
* | --- |
* | "Time and capacity" |
*
* @param {Auth_Ground_Item_TimeInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const auth_ground_item_time = /** @type {((inputs?: Auth_Ground_Item_TimeInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Ground_Item_TimeInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_auth_ground_item_time(inputs)
	if (locale === "he") return he_auth_ground_item_time(inputs)
	if (locale === "ur") return ur_auth_ground_item_time(inputs)
	if (locale === "es") return es_auth_ground_item_time(inputs)
	if (locale === "fr") return fr_auth_ground_item_time(inputs)
	if (locale === "de") return de_auth_ground_item_time(inputs)
	if (locale === "pt") return pt_auth_ground_item_time(inputs)
	if (locale === "hi") return hi_auth_ground_item_time(inputs)
	if (locale === "bn") return bn_auth_ground_item_time(inputs)
	return /** @type {LocalizedString} */ ("Time and capacity")
});